import React, { FC } from 'react';

const TrashIcon: FC = () => {
    return (
        <svg className={`svg-inline`} viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M3.33398 6.33398H16.6673"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.16797 6.33398L5.0013 16.334C5.0013 16.776 5.1769 17.1999 5.48946 17.5125C5.80202 17.8251 6.22594 18.0007 6.66797 18.0007H13.3346C13.7767 18.0007 14.2006 17.8251 14.5131 17.5125C14.8257 17.1999 15.0013 16.776 15.0013 16.334L15.8346 6.33398"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.5 6.33333V3.83333C7.5 3.61232 7.5878 3.40036 7.74408 3.24408C7.90036 3.0878 8.11232 3 8.33333 3H11.6667C11.8877 3 12.0996 3.0878 12.2559 3.24408C12.4122 3.40036 12.5 3.61232 12.5 3.83333V6.33333"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default TrashIcon;
